import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Crop75Icon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_7_5"}/>
}
